module.exports = __webpack_public_path__ + "media/images/easy-steps-5-1056cd5c8c55b49d9cc8446bcf3df57a.jpeg";